export type NormalizedCepAddress = {
  street: string;
  neighborhood: string;
  city: string;
  state: string;
  complement?: string;
};

export type CepLookupErrorCode = "INVALID_CEP" | "NOT_FOUND" | "LOOKUP_FAILED";

export class CepLookupError extends Error {
  code: CepLookupErrorCode;

  constructor(code: CepLookupErrorCode, message?: string) {
    super(message ?? code);
    this.name = "CepLookupError";
    this.code = code;
  }
}

type BrasilApiCepResponse = {
  cep?: string;
  state?: string;
  city?: string;
  neighborhood?: string;
  street?: string;
  service?: string;
};

export const mapCepErrorToMessage = (code: CepLookupErrorCode): string => {
  if (code === "INVALID_CEP") return "Informe um CEP válido (8 dígitos)";
  if (code === "NOT_FOUND") return "CEP não encontrado";
  return "Erro ao consultar CEP";
};

export const lookupCep = async (cep: string): Promise<NormalizedCepAddress> => {
  const cepDigits = cep.replace(/\D/g, "");
  if (cepDigits.length !== 8) {
    throw new CepLookupError("INVALID_CEP");
  }

  let response: Response;
  try {
    response = await fetch(`https://brasilapi.com.br/api/cep/v1/${cepDigits}`);
  } catch {
    throw new CepLookupError("LOOKUP_FAILED");
  }

  if (response.status === 404) {
    throw new CepLookupError("NOT_FOUND");
  }

  if (!response.ok) {
    throw new CepLookupError("LOOKUP_FAILED");
  }

  let data: BrasilApiCepResponse;
  try {
    data = (await response.json()) as BrasilApiCepResponse;
  } catch {
    throw new CepLookupError("LOOKUP_FAILED");
  }

  return {
    street: data.street ?? "",
    neighborhood: data.neighborhood ?? "",
    city: data.city ?? "",
    state: data.state ?? "",
    complement: undefined,
  };
};
